import { DEPLOY_ENV } from '../components/globals';

// Production and localdev are served the same origin as the app, where the
// Cloudflare edge worker (js/packages/cloudflare-worker) proxies Google Places.
// Other environments have no local worker, so they borrow staging's.
const getAddressInputUrl = () => {
  if (DEPLOY_ENV === 'production' || DEPLOY_ENV === 'localdev') {
    return '/_address-input';
  }
  return 'https://demo.simplersell.com/_address-input';
};

const ADDRESS_INPUT_URL = getAddressInputUrl();

export const ALLOWED_TYPES = ['street_address', 'premise', 'subpremise', 'route'];

export const generateGoogleMapsSessionToken = () => {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};

export const buildAutocompleteUrl = (query: string, sessionToken: string) => {
  return `${ADDRESS_INPUT_URL}/autocomplete?sessionToken=${sessionToken}&query=${encodeURIComponent(
    query,
  )}`;
};

export const buildCityAutocompleteUrl = (query: string, sessionToken: string) => {
  return `${ADDRESS_INPUT_URL}/autocomplete?sessionToken=${sessionToken}&query=${encodeURIComponent(
    query,
  )}&types=(regions)`;
};

export const buildPlacesUrl = ({
  source,
  placeId,
  addressToken,
  sessionToken,
}: {
  source: 'google' | 'casa';
  placeId?: string;
  addressToken?: string;
  sessionToken: string;
}) => {
  const baseUrl = `${ADDRESS_INPUT_URL}/place`;
  if (source === 'casa') {
    return baseUrl + `?addressToken=${addressToken}`;
  }
  return baseUrl + `?sessionToken=${sessionToken}&placeId=${placeId}`;
};
